export const mixin_fileUpload = {
    data() {
        return {
            fileList: [],
            uploadBusinessTypeCode: 'Flow', // 业务类型编码，组件可通过data覆盖
        };
    },
    props: {},
    watch: {},
    created() { },
    methods: {

        // 获取文件列表
        async getFileList() {
            this.fileList = [];
            if (this.fileDataId) {
                const res = await this.gitAnnexRequest(this.fileDataId);
                if (res) {
                    res.forEach(item => {
                        this.fileList.push({
                            url: `${this.GLOBAL.FILE_BASE_URL}file-manage/${item.AFI_Code}/download`,
                            status: 'done',
                            isImage: true,
                            FileID: item.FileID,
                            AFI_Code: item.AFI_Code,
                        });
                    });
                }
            }
        },
        uploadFileBefore() {
            if ((this.fileDataId || '') === '') {
                this.$toast('请先保存表单！');
                return false;
            }
            return true;
        },
        // 上传文件（支持多文件）
        async uploadFileMethod(param) {
            const files = Array.isArray(param) ? param : [param];
            const results = await Promise.allSettled(
                files.map(fileItem => this.uploadSingleFile(fileItem))
            );
            const successCount = results.filter(r => r.status === 'fulfilled').length;
            const failCount = results.filter(r => r.status === 'rejected').length;
            if (failCount === 0) {
                this.$toast.success(files.length > 1 ? `${successCount}个文件全部添加成功！` : '添加成功！');
            } else if (successCount === 0) {
                const firstError = results[0].reason?.ErrorCode?.Message || '上传失败';
                this.$toast.fail(firstError);
            } else {
                this.$toast(`${successCount}个成功，${failCount}个失败`);
            }
        },
        // 上传单个文件
        async uploadSingleFile(fileItem) {
            fileItem.status = 'uploading';
            fileItem.message = '上传中...';
            try {
                const tenantId = this.$takeTokenParameters('TenantId');
                const formData = new FormData();
                formData.append('FileType', 0);
                formData.append('BusinessTypeCode', this.uploadBusinessTypeCode);
                formData.append('DataId', this.fileDataId);
                formData.append('DirectoryId', '');
                formData.append('TenantId', tenantId);
                formData.append('File', fileItem.file);
                const url = `${this.GLOBAL.FILE_BASE_URL}file-manage?__tenant=${tenantId}`;
                const res = await this.$axios.post(url, formData);
                fileItem.status = 'done';
                fileItem.message = '上传成功';
                const firmRes = await this.uploadFirm(res, fileItem.file);
                // 通过回调将 uploadFirm 返回的文件id传给页面
                if (typeof this.callBackFun === 'function') {
                    this.callBackFun(firmRes);
                }
                return firmRes;
            } catch (error) {
                fileItem.status = 'failed';
                fileItem.message = '上传失败';
                throw error;
            }
        },
        // 上传成功，添加文件
        uploadFirm(res, fileData) {
            return this.$axios.post('/interfaceApi/basicplatform/simpleflow/filegroupinstance', {
                FileID: '',
                FileName: fileData.file_name,
                FileExt: '',
                FileSize: fileData.file_size,
                FileType: 2,
                FileSort: 0,
                FileDescription: '',
                ParentID: '0',
                BusinessType: '',
                KeyID: this.fileDataId,
                AFI_Code: res.Id,
            });
        },

        // 删除文件服务文件
        deleteFile(item) {
            const url = `${this.GLOBAL.FILE_BASE_URL}file-manage/${item.AFI_Code}`;
            this.$axios.delete(url, {})
                .then(() => {
                    this.deleteFile_process(item.FileID);
                })
                .catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 删除流程文件
        deleteFile_process(id) {
            this.$axios.delete(`/interfaceApi/basicplatform/simpleflow/filegroupinstance/${id}`, {})
                .then(() => {
                    this.$toast.success('删除成功！');
                })
                .catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 删除附件
        deleteFileData(file) {
            const path = `${this.GLOBAL.FILE_BASE_URL}file-manage/${file.FileID}`;
            return this.$axios.$delete(path);
        },

        // 获取文件列表请求
        gitAnnexRequest(id = '') {
            return this.$axios.$get(`/interfaceApi/basicplatform/simpleflow/filegroupinstance/${id}`);
        },
    },
};
